import { inject, Injectable } from '@angular/core';
import { LogsService } from '@services/logs';

@Injectable({ providedIn: 'root' })
export class ComponentLoaderService {
  private components: Map<string, unknown> = new Map();
  private readonly logsService = inject(LogsService);

  setComponents(componentsMap: Map<string, unknown>): void {
    this.components = componentsMap;
  }

  getComponent(name: string): unknown {
    const component = this.components.get(name);
    const componentName = (component as { name: string })?.name;
    if (!component) {
      this.logsService.error('ComponentLoaderService', `Component of type "${name}" not found`);
    } else {
      this.logsService.trace('ComponentLoaderService', `Getting component of type "${name}" (name: ${componentName})`);
    }
    return component;
  }
}
